import { render, staticRenderFns } from "./AdminTabs.vue?vue&type=template&id=3d021192&scoped=true&"
import script from "./AdminTabs.vue?vue&type=script&lang=js&"
export * from "./AdminTabs.vue?vue&type=script&lang=js&"
import style0 from "./AdminTabs.vue?vue&type=style&index=0&id=3d021192&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d021192",
  null
  
)

export default component.exports